import React from 'react'
import { Field } from 'formik'
import { isEmpty } from 'lodash'

import { TextArea } from '@/components/forms/formik'
import { FormField } from '@/components/forms/FormField'
import { LlmModelSelect } from '@/components/forms/formik/selects/LlmModelSelect'
import { RequiredIndicator } from '@/components/forms/RequiredIndicator'

import { LOOKUP_INSTRUCTIONS_PLACEHOLDER, TOOL_SOURCES, lookupVariable } from './tools.constants'
import {
  getLookupQuestionDefault,
  isCardOnlyPrompt,
  parseAllowedUrls,
  supportsAllowedUrls,
} from './tools.helpers'

export const LookupToolFields = ({ values, qaCopilotModelOptions }) => {
  const showModel =
    values.source !== TOOL_SOURCES.SHAREPOINT && !isCardOnlyPrompt(values.user_prompt)

  return (
    <>
      <p className="tool-form__filters-description" data-testid="tool-entity-lookup-note">
        Shows a card when the chosen entity comes up on a call. Add instructions to look each one up
        on the web or in the knowledge base, or leave them empty to show the card as is.
      </p>
      <div className="tool-form__field">
        <FormField label="Question to look up">
          <div className="form-caption">
            The question the lookup answers. Use {lookupVariable('name')} for the entity and{' '}
            {lookupVariable('entity_type')} for its type.
          </div>
          <Field
            name="lookup_question"
            component={TextArea}
            rows={2}
            placeholder={getLookupQuestionDefault(values.entity_type)}
            data-testid="tool-lookup-question"
          />
        </FormField>
      </div>
      <div className="tool-form__field">
        <div className="label-style">Formatting instructions</div>
        <Field
          name="user_prompt"
          component={TextArea}
          rows={3}
          placeholder={LOOKUP_INSTRUCTIONS_PLACEHOLDER}
          data-testid="tool-entity-instructions"
        />
      </div>
      {showModel && (
        <div className="tool-form__field">
          <div className="flex label-style">
            AI model
            <RequiredIndicator />
          </div>
          <Field
            name="llm_model_id"
            component={LlmModelSelect}
            options={
              isEmpty(parseAllowedUrls(values.allowed_urls))
                ? qaCopilotModelOptions
                : qaCopilotModelOptions.filter(supportsAllowedUrls)
            }
            required
          />
        </div>
      )}
      {values.source !== TOOL_SOURCES.SHAREPOINT && (
        <div className="tool-form__field">
          <div className="label-style">Allowed URLs</div>
          <Field
            name="allowed_urls"
            component={TextArea}
            rows={2}
            placeholder="https://example.com, https://docs.example.com"
            data-testid="tool-allowed-urls"
          />
        </div>
      )}
    </>
  )
}
